export const RANKING_SHOW_TABS = [
  'general',
  'publications',
  'collection',
  'search',
] as const;

export type RankingShowTab = (typeof RANKING_SHOW_TABS)[number];

export const RANKING_DEFAULT_TAB: RankingShowTab = 'general';
